import { useState, useEffect } from 'react';
import { Box, FormControl, makeStyles, Select, MenuItem, TextField, InputAdornment, Typography } from '@material-ui/core';
import { OIDValid } from '../helpers';

export const SNMPX_OPTION_TYPE = [
    {
        name: 'INTEGER',
        key: '0'
    },
    {
        name: 'GAUGE32',
        key: '1'
    },
    {
        name: 'OPAQUE FLOAT',
        key: '2'
    },
]

const useStyles = makeStyles(theme => ({
    devicesLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: '0.75rem',
    },
    input: {
        '& .MuiInputBase-input': {
            // Saco las flechitas al input type number
            '&::-webkit-inner-spin-button': {
                webkitAppearance: "none",
                mozAppearance: "none",
                appearance: " none",
                margin: 0
            },
        },
    },
}));

const SnmpxFilterOptions = ({ varState, setVarState, blockNodeSettings, setDisabledButtonSave }) => {
    const [stateForm, setStateForm] = useState({})
    const [oidValid, setOidValid] = useState(false)
    const classes = useStyles();

    useEffect(() => {
        if (varState?.a) {
            setDisabledButtonSave(OIDValid(varState?.a?.o))
            setStateForm(varState?.a)
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setVarState({
            ...varState,
            a: stateForm
        })
        // eslint-disable-next-line
    }, [stateForm])

    const handleChange = (e) => {
        let value = e.target.value
        let name = e.target.name
        if (name === 'o') {
            let flag = false
            if (OIDValid(value)) {
                flag = true
            }
            else {
                flag = false
            }
            setOidValid(flag)
            setDisabledButtonSave(flag)
        }
        setStateForm({
            ...stateForm,
            [name]: value
        })
    }

    return (
        <Box>
            <>
                {
                    (Array.isArray(blockNodeSettings?.atributes_keys) ? blockNodeSettings?.atributes_keys : []).map((element, indx) => {
                        return (
                            <Box key={indx} >
                                {element.key === 'd' ?
                                    <Box>
                                        <Box display="flex" alignItems="center" flexWrap="wrap" >
                                            <Box className={classes.devicesLabel}>
                                                {element.name}
                                            </Box>
                                        </Box>
                                        <Box width={'100%'}>
                                            <FormControl fullWidth>
                                                <Select
                                                    name={element.key}
                                                    value={stateForm?.[element.key] ? stateForm?.[element.key] : element?.default}
                                                    onChange={handleChange}
                                                >
                                                    {SNMPX_OPTION_TYPE.map((elem, indx) => (
                                                        <MenuItem
                                                            key={indx}
                                                            value={elem.key}
                                                        >
                                                            {elem.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                    :
                                    < Box width={'100%'} mt={2} className={classes.input}>
                                        <TextField
                                            fullWidth
                                            name={element.key}
                                            label={element.name}
                                            type={'number'}
                                            size="small"
                                            variant="outlined"
                                            value={stateForm?.[element.key] ?? ''}
                                            onChange={handleChange}
                                            color="primary"
                                            InputProps={{
                                                startAdornment: element.key === 'o' && (
                                                    <InputAdornment position="start" style={{ marginRight: 0 }}>
                                                        <Typography component="span" style={{ whiteSpace: 'nowrap' }}>
                                                            1.3.6.1.4.1.51701.0.
                                                        </Typography>
                                                    </InputAdornment>
                                                )
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Box>
                                }
                            </Box>
                        )
                    })
                }
                {
                    oidValid &&
                    < Box mt={1} color='red'>
                        Error valor OID
                    </Box>
                }
            </>
        </Box>
    );
}

export default SnmpxFilterOptions;



